import type { BreadcrumbPage } from 'src/components/BreadcrumbsNav';

import { Box } from '@mui/material';

import { Header } from 'src/components/Header';
import { BreadcrumbsNav } from 'src/components/BreadcrumbsNav';

export const SetupLayout = ({
  SideBarContent,
  children,
  withBreadcrumbs = false,
  breadcrumbsPages: breadcrumbPages = [],
}: {
  SideBarContent?: React.ReactNode;
  children: React.ReactNode;
  withBreadcrumbs?: boolean;
  breadcrumbsPages?: BreadcrumbPage[];
}) => {
  const hasSidebar = SideBarContent !== undefined;

  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.chalk,
        position: 'relative',
        // overflow: 'hidden',
      })}
    >
      {/* Orange background decoration */}
      <Box
        sx={(theme) => ({
          position: 'absolute',
          top: 0,
          right: 0,
          width: '66%',
          height: '300px',
          backgroundColor: theme.palette.background.clay,
          zIndex: 0,
        })}
      />
      <Header />
      <Box pt={7} pb={10}>
        {withBreadcrumbs && (
          <Box pr={6} pl={15} mb={3}>
            <BreadcrumbsNav pages={breadcrumbPages} />
          </Box>
        )}
        <Box
          // height="calc(100vh - 64px)"
          display="flex"
          gap={0}
          zIndex={1}
          position="relative"
        >
          {hasSidebar && (
            <Box width="34%" pr={6} pl={15}>
              {SideBarContent}
            </Box>
          )}

          {/* Main Content Area */}
          <Box
            width={hasSidebar ? '66%' : '100%'}
            pr={hasSidebar ? 0 : 15}
            pl={hasSidebar ? 0 : 15}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
